(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal.dataset.keepOpen === 'true') return;
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  class InfiniteScroll extends HTMLElement {
    constructor() {
      super();
      this.mode = this.dataset.mode;
      this.loading = false;
      this.observer = null;
    }

    connectedCallback() {
      this.sentinel = this.querySelector('.infinite-scroll__sentinel');
      this.button = this.querySelector('.infinite-scroll__button');
      this.spinner = this.querySelector('.infinite-scroll__spinner');

      if (!this.dataset.nextUrl) {
        this.remove();
        return;
      }

      if (this.mode === 'infinite' && this.sentinel) {
        this.observer = new IntersectionObserver(
          (entries) => {
            if (entries[0].isIntersecting) this.loadMore();
          },
          { rootMargin: '600px 0px' }
        );
        this.observer.observe(this.sentinel);
      }

      if (this.mode === 'load_more' && this.button) {
        this.button.addEventListener('click', () => this.loadMore());
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    async loadMore() {
      const nextUrl = this.dataset.nextUrl;
      if (!nextUrl || this.loading) return;

      this.loading = true;
      this.classList.add('infinite-scroll--loading');
      if (this.spinner) this.spinner.hidden = false;

      try {
        const response = await fetch(nextUrl);
        if (!response.ok) throw new Error(response.status);

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const newItems = doc.querySelectorAll('#product-grid > .grid__item');
        const currentGrid = document.getElementById('product-grid');

        if (currentGrid && newItems.length) {
          newItems.forEach((item) => {
            // Remove animation classes/attributes to avoid re-triggering them
            item.classList.remove('scroll-trigger', 'animate--slide-in');
            item.removeAttribute('data-cascade');
            item.style.removeProperty('--animation-order');
            currentGrid.appendChild(item);
          });
        }

        // Update next URL from the freshly fetched page
        const newSelf = doc.querySelector('infinite-scroll');
        const nextNextUrl = newSelf ? newSelf.dataset.nextUrl : '';

        if (nextNextUrl) {
          this.dataset.nextUrl = nextNextUrl;
          // Optional: reflect current page in URL bar
          history.replaceState({}, '', nextUrl);
        } else {
          if (this.observer) this.observer.disconnect();
          this.remove();
        }
      } catch (err) {
        console.error('[infinite-scroll]', err);
        this.classList.add('infinite-scroll--error');
      } finally {
        this.loading = false;
        this.classList.remove('infinite-scroll--loading');
        if (this.spinner) this.spinner.hidden = true;
      }
    }
  }

  if (!customElements.get('infinite-scroll')) {
    customElements.define('infinite-scroll', InfiniteScroll);
  }

  } catch(e) { console.error(e); }
})();
})();
